<div class="row ng-scope">
  <div class="col-12">
    <ul class="nav nav-tabs" id="lopHocTabs" role="tablist" style="margin-bottom:0px;">
      <li class="nav-item" role="presentation">
        <a class="nav-link"
           [class.active]="activeTab === 'thongtin'"
           id="thongtin-tab"
           (click)="setActiveTab('thongtin', $event)"
           href="javascript:void(0)"
           role="tab"
           aria-controls="thongtin"
           [attr.aria-selected]="activeTab === 'thongtin'">
          {{'Thông tin cơ bản' | translate}}
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link"
           [class.active]="activeTab === 'lichhoc'"
           id="lichhoc-tab"
           (click)="setActiveTab('lichhoc', $event)"
           href="javascript:void(0)"
           role="tab"
           aria-controls="lichhoc"
           [attr.aria-selected]="activeTab === 'lichhoc'">
          {{'Lịch học' | translate}}
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link"
           [class.active]="activeTab === 'hocvien'"
           id="hocvien-tab"
           (click)="setActiveTab('hocvien', $event)"
           href="javascript:void(0)"
           role="tab"
           aria-controls="hocvien"
           [attr.aria-selected]="activeTab === 'hocvien'">
          {{'Thông tin học sinh' | translate}}
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link"
           [class.active]="activeTab === 'khac'"
           id="khac-tab"
           (click)="setActiveTab('khac', $event)"
           href="javascript:void(0)"
           role="tab"
           aria-controls="khac"
           [attr.aria-selected]="activeTab === 'khac'">
          {{'Thông tin khác' | translate}}
        </a>
      </li>
    </ul>
  </div>
</div>

<!-- Tab Content -->
<div class="tab-content" id="lopHocTabContent">

  <!-- Tab 1: Thông tin cơ bản -->
  <div class="tab-pane"
       [class.fade]="true"
       [class.show]="activeTab === 'thongtin'"
       [class.active]="activeTab === 'thongtin'"
       id="thongtin"
       role="tabpanel"
       aria-labelledby="thongtin-tab">
    <div class="row ng-scope mt-3">
      <div class="col-12">
        <h4>Thông tin chung</h4>
      </div>

      <div class="col-12">
        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Mã lớp' | translate}}<span class="cred">(*)</span></label>
          <div class="col-xl-2">
            <input type="text" tabindex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ma">
          </div>
          <div class="col-xl-2">
            <ng-select #slKhoihoc
                       class="twcollong"
                       [tabIndex]="1"
                       [openOnEnter]="false"
                       [items]="dskhoilops"
                       bindValue="Id"
                       bindLabel="Ten"
                       [searchFn]="comboSearchFn2"
                       style="float:left;width:120px;margin-top:1px"
                       notFoundText="Không có dữ liệu"
                       [(ngModel)]="doituongSelect.KhoiLopId">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell_1">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <label class="col-xl-2 col-form-label">{{'Tên lớp' | translate}}<span class="cred">(*)</span></label>
          <div class="col-xl-4">
            <input type="text" tabindex="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ten">
          </div>
        </div>

        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Ngày nhập học' | translate}}</label>
          <div class="col-xl-4">
            <kendo-dateinput tabindex="3" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.TuNgay"></kendo-dateinput>
          </div>
          <label class="col-xl-2 col-form-label">{{'Ngày kết thúc' | translate}}</label>
          <div class="col-xl-4">
            <kendo-dateinput tabindex="4" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.DenNgay"></kendo-dateinput>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Cách tính' | translate}}/{{'Chu kỳ thu' | translate}}</label>
          <div class="col-xl-2">
            <ng-select #slChuongtrinh
                       class="twcollong"
                       [tabIndex]="5"
                       [openOnEnter]="false"
                       [items]="dsCachTinhHocPhis"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       (ngModelChange)="onCachTinhHocPhiChange()"
                       [(ngModel)]="doituongSelect.CachTinhHocPhi">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-xl-2">
            <ng-select #slChuongtrinh
                       class="twcollong"
                       [tabIndex]="6"
                       [openOnEnter]="false"
                       [items]="dsChuyKys"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       [disabled]="doituongSelect.CachTinhHocPhi !== 6 && doituongSelect.CachTinhHocPhi !== 1"
                       [(ngModel)]="doituongSelect.ChuKyThu">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <label class="col-xl-2 col-form-label">{{'Vị trí/Sĩ số' | translate}}</label>
          <div class="col-xl-2">
            <input class="form-control"
                   maxlength="20"
                   tabindex="7"
                   currencyMask
                   [(ngModel)]="doituongSelect.ViTri"
                   name="value"
                   [placeholder]="'Vị trí'"
                   [options]="ngxCurrencyOptions" autocomplete="off" />
          </div>
          <div class="col-xl-2">
            <input class="form-control"
                   maxlength="20"
                   tabindex="8"
                   currencyMask
                   [(ngModel)]="doituongSelect.SiSo"
                   name="value"
                   [placeholder]="'Sĩ số'"
                   [options]="ngxCurrencyOptions" autocomplete="off" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Tình trạng' | translate}}<span class="cred">(*)</span></label>
          <div class="col-xl-4">
            <ng-select #slChuongtrinh
                       class="twcollong"
                       [tabIndex]="9"
                       [openOnEnter]="false"
                       [items]="inputtinhtrangs"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       [(ngModel)]="doituongSelect.TinhTrang">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <label class="col-xl-2 col-form-label">{{'Số buổi/Giá theo buổi/Tháng' | translate}}</label>
          <div class="col-xl-1">
            <input class="form-control"
                   maxlength="20"
                   tabindex="10"
                   currencyMask
                   [(ngModel)]="doituongSelect.SoBuoi"
                   name="value"
                   [placeholder]="'Số buổi'"
                   [options]="ngxCurrencyOptions" autocomplete="off" />
          </div>
          <div class="col-xl-1">
            <input class="form-control"
                   maxlength="20"
                   tabindex="11"
                   currencyMask
                   [(ngModel)]="doituongSelect.ChiPhiDaoTao_CT"
                   name="value"
                   [placeholder]="'Giá tiền/ 1 buổi'"
                   [options]="ngxCurrencyOptions" autocomplete="off" />
          </div>
          <div class="col-xl-2">
            <input class="form-control"
                   maxlength="20"
                   tabindex="12"
                   currencyMask
                   [(ngModel)]="doituongSelect.TongChiPhi_CT"
                   name="value"
                   [placeholder]="'Giá tiền 1 tháng hoặc 1 gói học'"
                   [options]="ngxCurrencyOptions" autocomplete="off" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Phòng học' | translate}}</label>
          <div class="col-xl-4">
            <ng-select #slPhongHoc
                       class="twcollong"
                       [tabIndex]="13"
                       [openOnEnter]="false"
                       [items]="inputphonghocs"
                       bindValue="id"
                       bindLabel="ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       [(ngModel)]="doituongSelect.PhongHocId">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <label class="col-xl-2 col-form-label">{{'Nhóm học sinh' | translate}}</label>
          <div class="col-xl-4">
            <ng-select style="width:100%;"
                       [openOnEnter]="false"
                       [items]="items"
                       tabindex="14"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       placeholder=""
                       [(ngModel)]="doituongSelect.HangMucId">
            </ng-select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Chứng chỉ' | translate}}</label>
          <div class="col-xl-4">
            <ng-select style="width:100%;"
                       [openOnEnter]="false"
                       [items]="inputchungchis"
                       tabindex="15"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       placeholder=""
                       [(ngModel)]="doituongSelect.ChungChiId">
            </ng-select>
          </div>
          <label class="col-xl-2 col-form-label">{{'Hình thức đào tạo' | translate}}</label>
          <div class="col-xl-4">
            <ng-select style="width:100%;"
                       [openOnEnter]="false"
                       [items]="inputhinhthucdaotaos"
                       tabindex="16"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       placeholder=""
                       [(ngModel)]="doituongSelect.HinhThucDaoTaoId">
            </ng-select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Cách gửi thông báo' | translate}}</label>
          <div class="col-xl-4">
            <ng-select #slCachGuiThongBao
                       class="twcollong"
                       [tabIndex]="17"
                       [openOnEnter]="false"
                       [items]="dsCachGuiThongBaos"
                       bindValue="id"
                       bindLabel="ten"
                       notFoundText="Không có dữ liệu"
                       (change)="changeCachGuiThongBao($event)"
                       [(ngModel)]="doituongSelect.CachGuiThongBao">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <label class="col-xl-2 col-form-label">{{getLabelDieuKienGui() | translate}}</label>
          <div class="col-xl-4">
            <input class="form-control"
                   maxlength="20"
                   tabindex="18"
                   currencyMask
                   [(ngModel)]="doituongSelect.DieuKienGui"
                   name="value"
                   [placeholder]="getPlaceholderDieuKienGui()"
                   [options]="ngxCurrencyOptions" autocomplete="off" />
          </div>
        </div>

        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Phân loại' | translate}}<span class="cred">(*)</span></label>
          <div class="col-xl-4">
            <ng-select #slPhanLoai
                       class="twcollong"
                       autofocus
                       [tabIndex]="19"
                       [openOnEnter]="false"
                       [items]="inputphanloais"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       [(ngModel)]="doituongSelect.PhanLoai">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <label class="col-xl-2 col-form-label">{{'Độ tuổi' | translate}}</label>
          <div class="col-xl-4">
            <input type="text" tabindex="20" class="form-control" placeholder="" [(ngModel)]="doituongSelect.DoTuoi">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Ghi chú' | translate}}</label>
          <div class="col-xl-10">
            <textarea class="form-control" tabindex="21" placeholder="" rows="2" [(ngModel)]="doituongSelect.MoTa"></textarea>
          </div>
        </div>

        <div class="col-12">
          <h4>Thông tin nhân viên hỗ trợ</h4>
        </div>

        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Giáo viên chính' | translate}}<span class="cred">(*)</span></label>
          <div class="col-xl-4">
            <ng-select #slGiaoVienChinh
                       class="twcollong"
                       [tabIndex]="22"
                       [openOnEnter]="false"
                       [items]="inputGiangViens"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       [(ngModel)]="doituongSelect.GiangVien">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <label class="col-xl-2 col-form-label">{{'Người hỗ trợ' | translate}}</label>
          <div class="col-xl-4">
            <ng-select #slNguoiHoTro
                       class="twcollong"
                       [tabIndex]="23"
                       [openOnEnter]="false"
                       [items]="inputGiangViens"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       [(ngModel)]="doituongSelect.NguoiHoTro">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Chăm sóc' | translate}}</label>
          <div class="col-xl-4">
            <ng-select #slGiaoVienChinh
                       class="twcollong"
                       [tabIndex]="24"
                       [openOnEnter]="false"
                       [items]="inputGiangViens"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       [(ngModel)]="doituongSelect.NguoiChamSoc">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <label class="col-xl-2 col-form-label">{{'Trợ giảng 1' | translate}}</label>
          <div class="col-xl-4">
            <ng-select #slNguoiHoTro
                       class="twcollong"
                       [tabIndex]="24"
                       [openOnEnter]="false"
                       [items]="inputGiangViens"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       [(ngModel)]="doituongSelect.TroGiang1">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Trợ giảng 2' | translate}}</label>
          <div class="col-xl-4">
            <ng-select #slGiaoVienChinh
                       class="twcollong"
                       [tabIndex]="26"
                       [openOnEnter]="false"
                       [items]="inputGiangViens"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       [(ngModel)]="doituongSelect.TroGiang2">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <label class="col-xl-2 col-form-label">{{'Chương trình' | translate}}</label>
          <div class="col-xl-4">
            <ng-select #slChuongtrinh
                       class="twcollong"
                       [tabIndex]="27"
                       [openOnEnter]="false"
                       [items]="dschuongtrinhs"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       [(ngModel)]="doituongSelect.ChuongTrinhHocId">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <div class="modal-footer" style="display: flex; justify-content: space-between; flex: 1;">
        <div style="display:flex;">
          <div class="checkbox c-checkbox">
            <label>
              <input tabIndex="26" type="checkbox" [(ngModel)]="doituongSelect.TrangThai2" />
              <span class="fa fa-check"></span> {{'Hoạt động' | translate}}
            </label>
          </div>
          <div class="checkbox c-checkbox" style="margin-left: 20px;">
            <label>
              <input tabIndex="27" type="checkbox"
                     [(ngModel)]="autoHocPhiChecked"
                     (ngModelChange)="onAutoHocPhiChange($event)" />
              <span class="fa fa-check"></span> Trừ học phí buổi nghỉ
            </label>
          </div>
          <div class="checkbox c-checkbox" style="margin-left: 20px;">
            <label>
              <input tabIndex="28" type="checkbox"
                     [(ngModel)]="motNgayChiTinhMotCaChecked"
                     (ngModelChange)="onMotNgayChiTinhMotCaChange($event)" />
              <span class="fa fa-check"></span> {{'1 ngày chỉ tính 1 ca' | translate}}
            </label>
          </div>
          <div class="checkbox c-checkbox" style="margin-left: 20px;">
            <label>
              <input tabIndex="29" type="checkbox"
                     [(ngModel)]="isTronThangChecked"
                     (ngModelChange)="onIsTronThangChange($event)" />
              <span class="fa fa-check"></span> {{'Tính học phí tròn tháng' | translate}}
            </label>
          </div>
        </div>

        <div class="">
          <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
          <button style="float:left !important" *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
        </div>
      </div>


    </div>
  </div>

  <!-- Tab 2: Lịch học -->
  <div class="tab-pane"
       [class.fade]="true"
       [class.show]="activeTab === 'lichhoc'"
       [class.active]="activeTab === 'lichhoc'"
       id="lichhoc"
       role="tabpanel"
       aria-labelledby="lichhoc-tab">
    <div class="row ng-scope mt-3">
            
      <!-- Lịch học cho từng thứ trong tuần -->
      <div class="col-12" *ngFor="let daySchedule of weeklySchedule; let dayIndex = index; trackBy: trackByDayId">
        <div class="card mb-3">
          <div class="card-header">
            <div class="row align-items-center" style="flex:1;">
              <div class="col-6">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox"
                         [id]="'day-' + daySchedule.dayId"
                         [(ngModel)]="daySchedule.isActive"
                         (change)="onDayActiveChange(daySchedule)">
                  <label class="form-check-label" [for]="'day-' + daySchedule.dayId">
                    <strong>{{daySchedule.dayName}}</strong>
                  </label>
                </div>
              </div>
              <div class="col-6 text-right">
                <button type="button" class="btn btn-sm btn-primary"
                        [disabled]="!daySchedule.isActive"
                        (click)="addScheduleRow(daySchedule)">
                  <i class="fa fa-plus"></i> Thêm ca học
                </button>
              </div>
            </div>
          </div>

          <div class="card-body" *ngIf="daySchedule.isActive">
            <div class="">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th width="12%">{{'Từ giờ' | translate}}</th>
                    <th width="12%">{{'Đến giờ' | translate}}</th>
                    <th width="13%">{{'Giá tiền 1 ca' | translate}}</th>
                    <th width="20%">{{'Phòng học' | translate}}</th>
                    <th width="20%">{{'Giáo viên' | translate}}</th>
                    <th width="18%">{{'Ghi chú' | translate}}</th>
                    <th width="5%"></th>
                  </tr>
                </thead>
                <tbody>
                  <!-- FIX: Đổi tên biến từ j thành scheduleIndex để rõ ràng hơn -->
                  <tr *ngFor="let schedule of daySchedule.schedules; let scheduleIndex = index; trackBy: trackByScheduleIndex">
                    <td>
                      <kendo-dateinput style="width:100%;"
                                       [format]="'HH:mm'"
                                       [(value)]="schedule.tuGio">
                      </kendo-dateinput>
                    </td>
                    <td>
                      <kendo-dateinput style="width:100%;"
                                       [format]="'HH:mm'"
                                       [(value)]="schedule.denGio">
                      </kendo-dateinput>
                    </td>
                    <td>
                      <input class="form-control"
                             currencyMask
                             [(ngModel)]="schedule.giaTien1Ca"
                             [name]="'giatien1ca-' + dayIndex + '-' + scheduleIndex"
                             placeholder="Giá tiền"
                             [options]="ngxCurrencyOptions"
                             autocomplete="off" />
                    </td>
                    <td>
                      <ng-select [items]="inputphonghocs"
                                 bindValue="id"
                                 bindLabel="ten"
                                 notFoundText="Không có dữ liệu"
                                 [searchFn]="comboSearchFn2"
                                 [(ngModel)]="schedule.phongHocId">
                        <ng-template ng-option-tmp let-item="item">
                          <div class="rTableRow">
                            <div class="rTableCell">{{item.ten}}</div>
                          </div>
                        </ng-template>
                      </ng-select>
                    </td>
                    <td>
                      <ng-select [items]="inputGiangViens"
                                 bindValue="Id"
                                 bindLabel="Ten"
                                 notFoundText="Không có dữ liệu"
                                 [searchFn]="comboSearchFn2"
                                 [(ngModel)]="schedule.giaoVienId">
                        <ng-template ng-option-tmp let-item="item">
                          <div class="rTableRow">
                            <div class="rTableCell">{{item.Ten}}</div>
                          </div>
                        </ng-template>
                      </ng-select>
                    </td>
                    <td>
                      <input type="text" class="form-control"
                             [(ngModel)]="schedule.ghiChu"
                             placeholder="Ghi chú">
                    </td>
                    <td>
                      <!-- FIX: Truyền scheduleIndex thay vì dayIndex (i) -->
                      <button class="btn btn-sm btn-danger"
                              (click)="deleteScheduleRowWithConfirm(daySchedule, schedule, scheduleIndex)"
                              [disabled]="!canDeleteSchedule(schedule)"
                              title="Xóa ca học này">
                        <i class="fa fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="daySchedule.schedules.length === 0">
                    <td colspan="7" class="text-center text-muted">
                      Chưa có ca học nào. Nhấn "Thêm ca học" để thêm mới.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Thêm footer cho tab Lịch học -->
      <div class="col-12 mt-3">
        <div class="card">
          <div class="card-footer" style="background-color: #f8f9fa;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-muted">
                <small>
                  <i class="fa fa-info-circle"></i>
                  Bạn có thể lưu riêng lịch học mà không cần lưu toàn bộ thông tin lớp
                </small>
              </div>
              <div>
                <button type="button"
                        class="btn btn-success"
                        [disabled]="!doituongSelect.Id || isSavingSchedule"
                        (click)="saveLichHocOnly()"
                        title="Lưu riêng lịch học">
                  <i class="fa fa-save" [class.fa-spin]="isSavingSchedule"></i>
                  {{isSavingSchedule ? 'Đang lưu...' : 'Lưu lịch học'}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Tab 3: Thông tin học sinh -->
  <div class="tab-pane"
       [class.fade]="true"
       [class.show]="activeTab === 'hocvien'"
       [class.active]="activeTab === 'hocvien'"
       id="hocvien"
       role="tabpanel"
       aria-labelledby="hocvien-tab">
    <div class="row ng-scope mt-3">

      <div class="col-12">
        <div class="">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th width="150px">{{'Tên học sinh' | translate}}</th>
                <th width="100px">{{'Ngày vào lớp' | translate}}</th>
                <th width="120px">{{'Học phí' | translate}}</th>
                <th width="120px">{{'Tiền xe đưa đón' | translate}}</th>
                <th width="100px">{{'Cố định học phí' | translate}}</th>
                <th width="100px">{{'Bỏ tính học phí' | translate}}</th>
                <th>{{'Ca học' | translate}}</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let hocvien of danhSachHocVien; let i = index">
                <td>
                  <input type="text" class="form-control"
                         [(ngModel)]="hocvien.tenHocVien"
                         placeholder="Nhập tên học sinh">
                </td>
                <td>
                  <kendo-dateinput style="width:100%;"
                                   [format]="'dd/MM/yyyy'"
                                   [(value)]="hocvien.ngayVaoLop">
                  </kendo-dateinput>
                </td>
                <td>
                  <input class="form-control"
                         currencyMask
                         [(ngModel)]="hocvien.hocPhi"
                         name="hocphi"
                         placeholder="Học phí"
                         [options]="ngxCurrencyOptions"
                         autocomplete="off" />
                </td>
                <td>
                  <input class="form-control"
                         currencyMask
                         [(ngModel)]="hocvien.chiPhiDiLai"
                         name="chiphidilai"
                         placeholder="Tiền xe đưa đón"
                         [options]="ngxCurrencyOptions"
                         autocomplete="off" />
                </td>
                <td class="text-center">
                  <div class="checkbox c-checkbox">
                    <label>
                      <input type="checkbox"
                             [(ngModel)]="hocvien.isCoDinhThang" />
                      <span class="fa fa-check"></span>
                    </label>
                  </div>
                </td>
                <td class="text-center">
                  <div class="checkbox c-checkbox">
                    <label>
                      <input type="checkbox"
                             [(ngModel)]="hocvien.isBoTinhHocPhi" />
                      <span class="fa fa-check"></span>
                    </label>
                  </div>
                </td>
                <td>
                 
                  <!-- Danh sách checkbox các ca học -->
                  <div class="ca-hoc-selection" style="max-height: 120px; overflow-y: auto; border: 1px solid #ddd; padding: 8px; border-radius: 4px; display: flex;">
                    <div class="form-check"
                         *ngFor="let caHoc of getAvailableCaHocs()"
                         style="margin-bottom: 5px;">
                      <input class="form-check-input"
                             type="checkbox"
                             [id]="'cahoc-' + i + '-' + caHoc.Id"
                             [checked]="isCaHocSelected(hocvien.caHocIds, caHoc.Id)"
                             (change)="toggleCaHocSelection(hocvien, caHoc.Id, $event)">
                      <label class="form-check-label"
                             [for]="'cahoc-' + i + '-' + caHoc.Id"
                             style="font-size: 12px; margin-left: 5px;">
                        {{caHoc.ten}}
                      </label>
                    </div>
                    <div *ngIf="getAvailableCaHocs().length === 0"
                         class="text-muted text-center"
                         style="font-size: 12px; padding: 10px;">
                      Không có ca học nào
                    </div>
                  </div>
                </td>

              </tr>
              <tr *ngIf="danhSachHocVien.length === 0">
                <td colspan="7" class="text-center text-muted">
                  Chưa có học sinh nào.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Thêm footer cho tab Lịch học -->
      <div class="col-12 mt-3">
        <div class="card">
          <div class="card-footer" style="background-color: #f8f9fa;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="text-muted">
                <small>
                  <i class="fa fa-info-circle"></i>
                  Bạn có thể lưu riêng học sinh mà không cần lưu toàn bộ thông tin lớp
                </small>
              </div>
              <div>
                <button type="button"
                        class="btn btn-success"
                        [disabled]="!doituongSelect.Id"
                        (click)="saveHocVienData()"
                        title="Lưu danh sách học sinh">
                  <i class="fa fa-save" [class.fa-spin]="isSavingSchedule"></i>
                  {{isSavingSchedule ? 'Đang lưu...' : 'Lưu thông tin học sinh'}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Tab 4: Thông tin khác -->
  <div class="tab-pane"
       [class.fade]="true"
       [class.show]="activeTab === 'khac'"
       [class.active]="activeTab === 'khac'"
       id="khac"
       role="tabpanel"
       aria-labelledby="khac-tab">
    <div class="row ng-scope mt-3">
      <div class="col-12">
        <h4>Thông tin khác</h4>
      </div>

      <div class="col-12">


        <div class="form-group row">
          <label class="col-xl-2 col-form-label">{{'Số tiền ăn 1 buổi' | translate}}</label>
          <div class="col-xl-4">
            <input class="form-control"
                   maxlength="20"
                   tabindex="10"
                   currencyMask
                   [(ngModel)]="doituongSelect.SoTienAnCa"
                   name="value"
                   [placeholder]="'Số tiền ăn ca 1 buổi của học sinh'"
                   [options]="ngxCurrencyOptions" autocomplete="off" />
          </div>
          <label class="col-xl-2 col-form-label">{{'Tài khoản ngân hàng' | translate}}</label>
          <div class="col-xl-4">
            <ng-select #slTaiKhoanNganHang
                       class="twcollong"
                       [tabIndex]="11"
                       [openOnEnter]="false"
                       [items]="inputtaikhoannganhangs"
                       bindValue="Id"
                       bindLabel="ChuTaiKhoan"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       [(ngModel)]="doituongSelect.BankId">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.ChuTaiKhoan}} - {{item.SoTaiKhoan}}</div>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>


      </div>

      <div class="modal-footer" style="display: flex; justify-content: space-between; flex: 1;">
        <div style="display:flex;">
          <!--<div class="checkbox c-checkbox">
            <label>
              <input tabIndex="26" type="checkbox" [(ngModel)]="doituongSelect.TrangThai2" />
              <span class="fa fa-check"></span> {{'Hoạt động' | translate}}
            </label>
          </div>
          <div class="checkbox c-checkbox" style="margin-left: 20px;">
            <label>
              <input tabIndex="27" type="checkbox"
                     [(ngModel)]="autoHocPhiChecked"
                     (ngModelChange)="onAutoHocPhiChange($event)" />
              <span class="fa fa-check"></span> {{'Tự động tính học phí' | translate}}
            </label>
          </div>
          <div class="checkbox c-checkbox" style="margin-left: 20px;">
            <label>
              <input tabIndex="28" type="checkbox"
                     [(ngModel)]="motNgayChiTinhMotCaChecked"
                     (ngModelChange)="onMotNgayChiTinhMotCaChange($event)" />
              <span class="fa fa-check"></span> {{'1 ngày chỉ tính 1 ca' | translate}}
            </label>
          </div>
          <div class="checkbox c-checkbox" style="margin-left: 20px;">
            <label>
              <input tabIndex="29" type="checkbox"
                     [(ngModel)]="isTronThangChecked"
                     (ngModelChange)="onIsTronThangChange($event)" />
              <span class="fa fa-check"></span> {{'Tính học phí tròn tháng' | translate}}
            </label>
          </div>-->
        </div>

        <div class="">
          <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
          <button style="float:left !important" *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
        </div>
      </div>


    </div>
  </div>

</div>



<!-- Keep existing modals -->
<div id='target' class="control-section">
  <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
              [target]='target' [width]='dialogWidth'>
    <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                     [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                     [contextMenuSettings]='contextMenuSettings'
                     [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)" [showThumbnail]="false">
    </ejs-filemanager>
  </ejs-dialog>
</div>

<bs-modal #mdDanhSachLichHoc class="modal fade show in" [cssClass]="'modal7'" [backdrop]="'static'">
  <div class="modal-header">
    <h4 class="modal-title">{{'Danh sách lịch học' | translate}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdDanhSachLichHoc.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-daotao-danhsachlichhocedit #dtedslichhocedit (savect)="save_danhsachlichhoc($event)"></app-daotao-danhsachlichhocedit>
  </bs-modal-body>
</bs-modal>
